Customer.Dashboard ||= {}

class Customer.Dashboard.ResponseScheduleView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/response_schedule']

  events:
    'change #response-schedule-date': 'onChangeDate'
    'change #response-schedule-time': 'onChangeTime'
    'change #response-schedule-ticket-status-after-successful-impact': 'onChangeTicketStatusAfterSuccessfulImpact'
    'click #cancel': 'onClickCancel'
    'click #suspend': 'onClickSuspend'
    'click #save': 'onClickSave'

  initialize: (@options = {}) ->
    @parentView = @options.parentView
    @responseSchedule = @options.responseSchedule
    @edit = @options.edit

  render: =>
    @$el.html(@template(@))
    @

  show: ->
    modal = @$el.find('#response-schedule-edit')
    modal.modal()
    @initializeDatepickers()
    @$el.find('#suspend').show()
    @updateSaveButtonStatus()
    setTimeout =>
      @$el.find('.response-schedule-note').focus()
    , 500

  initializeDatepickers: ->
    @initializeDatepickerDay()
    @initializeDatepickerHour()

  initializeDatepickerDay: ->
    datepickerOptions = {
      todayBtn: 'linked'
      autoclose: true
      format: 'yyyy-mm-dd'
    }
    if @edit
      timestamp = @responseSchedule.scheduledImpactTimestamp()
      date = new Date(timestamp)
      datepickerOptions.startDate = _.min([date, new Date()])
    else
      date = new Date()
      datepickerOptions.startDate = date

    @$el.find('.datepicker').datepicker(datepickerOptions)
    @$el.find('.datepicker').datepicker('setDate', date)

  initializeDatepickerHour: ->
    timestamp = @responseSchedule.scheduledImpactTimestamp()
    @$el.find('.timepicker').modifiedwickedpicker(
      twentyFour: true
      now: moment(timestamp).format('HH:mm')
    )

  onChangeDate: ->
    @updateSaveButtonStatus()

  onChangeTime: ->
    @updateSaveButtonStatus()

  onChangeTicketStatusAfterSuccessfulImpact: ->
    @updateSaveButtonStatus()

  updateSaveButtonStatus: ->
    @$el.find('#save').prop('disabled', !@allInputIsValid())

  allInputIsValid: ->
    @isFutureDate() && @ticketStatusIsSelected()

  isFutureDate: ->
    selectedDate = @$el.find('.datepicker').val()
    return true if selectedDate == '' # not loaded yet
    now = moment()

    return true if moment(selectedDate).startOf('day').valueOf() > now.endOf('day').valueOf()
    return false if moment(selectedDate).endOf('day').valueOf() < now.startOf('day').valueOf()

    @$el.find('.timepicker').val() > moment().format("HH:mm")

  ticketStatusIsSelected: ->
    @$el.find('#response-schedule-ticket-status-after-successful-impact').val()

  selectedTimestamp: ->
    date = $('#response-schedule-date').val().replace(/\s+/g, '')
    time = $('#response-schedule-time').val()
    timezone = moment().format('Z')
    moment(date + "T" + time + timezone).unix() * 1000

  onClickCancel: (event) ->
    @$el.find('.response-schedule-date-and-time').click()

  onClickSuspend: (event) ->
    @$el.find('.response-schedule-date-and-time').click()
    swal({
      title: I18n.t('customer.dashboard.conversations.details.response.schedule.suspend_confirmation')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('customer.dashboard.conversations.details.response.schedule.suspend_yes')
      cancelButtonText: I18n.t('customer.dashboard.conversations.details.response.schedule.suspend_no')
      closeOnConfirm: true
    }, =>
      @$el.find('#suspend').hide()
      @responseSchedule.setScheduledImpactTimestamp(@selectedTimestamp()) # only to avoid date format problems
      @responseSchedule.suspendByOperator()
      @doSave(event)
    )

  onClickSave: (event) ->
    @$el.find('.response-schedule-date-and-time').click()
    @responseSchedule.setScheduledImpactTimestamp(@selectedTimestamp())
    @responseSchedule.setTicketStatusAfterSuccessfulImpact(@$el.find('.response-schedule-ticket-status-after-successful-impact').val())
    @responseSchedule.setNote(@$el.find('.response-schedule-note').val())
    @doSave(event)

  doSave: (event) ->
    @$el.find('#save').hide()
    @$el.find('#saving').show()
    @parentView.saveResponseSchedule(event, @responseSchedule, {
      success: =>
        console.log('saved response schedule successfully')
        setTimeout =>
          @$el.find('#save').show()
          @$el.find('#saving').hide()
        , 1000
        @$el.find('#response-schedule-edit').modal('hide')
      error: (response) =>
        console.log('error saving response schedule')
        console.log(response)
        if response.status == 400
          response.skipAttributesErrorDetail = true
        else
          showError response.responseJSON?.error || I18n.t('generic_error_message')
        @$el.find('#save').show()
        @$el.find('#saving').hide()
    })
